import "./CorrespondenceTable.scss";
import InputDate from "core/inputs/input-date/InputDate";
import { Typography } from "core/typography/Typography";
import React, { useContext } from "react";
import Button from "core/buttons/button/Button";
import Icon from "core/icon/Icon";
import { FormattedMessage } from "react-intl";
import InfoContext from "pages/InfoContext";
import InputSelect from "core/inputs/input-select/InputSelect";
import { EXPORT_BUTTONS, QUERY_STATUS } from "constants/constants";


const CorrespondenceForm = () => {
  const {
    startDateFilter,
    setStartDateFilter,
    endDateFilter,
    setEndDateFilter,
    csltStrFilter,
    setCsltStrFilter,
    CORRESPONDENCE_TABLE_CSLT_STR_FILTER_OPTIONS,
    lang,
    search,
    downloadExport,
    correspondenceExportStatus,
    exportBtnClicked,
    loadTimelineCorrespondance,
    formatDateToYYYYMMDD,
  } = useContext(InfoContext);

  const dateFilterSetterHandler = (setter, value) => {
    setter(value ? formatDateToYYYYMMDD(value) : null);
  };

  return (
    <div className="correspondence-filters-wrapper">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={<FormattedMessage id="filters" defaultMessage="FILTRES" />}
      />
      <div className="section-1">
        <div className="line-1">
          <div className="cell-padding">
            <InputDate
              lang={lang}
              label={{
                id: "start_date",
                defaultMessage: "Date de début",
              }}
              id="start-date-filter"
              onChange={(e) =>
                dateFilterSetterHandler(setStartDateFilter, e?.target?.value)
              }
              value={startDateFilter?.toString()}
              required
              errors={!startDateFilter && { ref: "start-date-filter" }}
            />
          </div>
          <div className="cell-padding">
            <InputDate
              lang={lang}
              label={{
                id: "end_date",
                defaultMessage: "Date de fin",
              }}
              id="end-date-filter"
              onChange={(e) =>
                dateFilterSetterHandler(setEndDateFilter, e?.target?.value)
              }
              value={endDateFilter?.toString()}
              required
              errors={!endDateFilter && { ref: "end-date-filter" }}
            />
          </div>
          <div className="cell-padding">
            <InputSelect
              name="cslt_str_filter"
              errors={{}}
              label={{
                id: "cslt_str",
                defaultMessage: "Consultants / Sous-traitants",
              }}
              id="usertype-title-filter"
              setValue={(name, value) => setCsltStrFilter(value)}
              value={csltStrFilter}
              options={CORRESPONDENCE_TABLE_CSLT_STR_FILTER_OPTIONS}
            />
          </div>
        </div>
      </div>
      <Button
        color="btn-medium gray-700"
        type="submit"
        id="dashboard_btn"
        onClick={() => search()}
        disabled={loadTimelineCorrespondance === QUERY_STATUS.LOADING}
      >
        <FormattedMessage id="dashboard_btn" defaultMessage="Rechercher" />
      </Button>
      <div className="export-buttons">
        <Button
          className="btn-outlined"
          size="medium"
          color="white"
          onClick={() => downloadExport({ exportType: EXPORT_BUTTONS.CA })}
          disabled={exportBtnClicked === EXPORT_BUTTONS.CA && correspondenceExportStatus === QUERY_STATUS.LOADING}
        >
          <Icon
            icon="sheet"
            color="green"
            height={20}
            marginBottom={-3}
            marginRight={8}
          />
          <FormattedMessage id={"export_ca"} defaultMessage={"Export CA"} />
        </Button>
        <Button
          className="btn-outlined"
          size="medium"
          color="white"
          onClick={() =>
            downloadExport({ exportType: EXPORT_BUTTONS.CORRESPONDENCE })
          }
          disabled={
            exportBtnClicked === EXPORT_BUTTONS.CORRESPONDENCE && correspondenceExportStatus === QUERY_STATUS.LOADING
          }
        >
          <Icon
            icon="sheet"
            color="green"
            height={20}
            marginBottom={-3}
            marginRight={8}
          />
          <FormattedMessage
            id={"export_excel"}
            defaultMessage={"Exporter en Excel"}
          />
        </Button>
      </div>
    </div>
  );
};

export default CorrespondenceForm;
